import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import { ERoutes } from "../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../components";
import { useGlobalData } from "../../../contexts";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { ClinicApi, ClinicGridDto, ClinicSearch } from "../../../api";

export interface IClinicListPageProps {}

export const ClinicListPage: React.FunctionComponent<IClinicListPageProps> = (props) => {
  const api = useApiService(ClinicApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ClinicGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.clinic}/${row.clinicId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.clinic}/${row.clinicId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "Name",
        render: (row: ClinicGridDto) => `${row.name}`,
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "Email",
        render: (row: ClinicGridDto) => `${row.email}`,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "Phone number",
        render: (row: ClinicGridDto) => {
          if (!row.phoneNumber) {
            return "/";
          } else {
            return `${row.phoneNumber}`;
          }
        },
        computed: true,
        disableSorting: true,
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.clinic}/0/detail/edit`);
  }, [history]);

  const search = React.useCallback(
    (sObj) => api.baseSearch(ClinicSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(ClinicSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }))
      }
      addFunc={addItemFunction}
      sortKeys={{ Name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Clinics) }]}
    />
  );
};
